export default {
  'it-IT': {
    returnDetailsHeading: 'Dettagli reso n. {returnNumber}',
    returnDate: 'Richiesta inviata il:',
    returnStatus: 'Stato del reso:',
    returnType: 'Tipo di reso:',
    orderNumber: "Reso relativo all'ordine n. {orderNumber}",
    orderDate: 'Ordine effettuato il:',
    paymentType: 'Metodo di pagamento ordine:',
    returnManner: 'Modalità di invio:',
    amountRefunded: 'Importo del rimborso:',
    downloadPdf: 'Scarica il pdf',
    pdfInstructions: "Stampa il modulo e inseriscilo all'interno del pacco",
    downloadLabel: "Scarica l'etichetta",
    labelInstructions: "Stampa l'etichetta e incollala sul pacco",
    returnedItems: 'Articoli restituiti',
    reason: 'Motivazione',
    notes: 'Note',
    backToMyOrders: 'Torna ai miei ordini',
    reasons: {
      Mistake: 'Acquistato per errore',
      FoundCheaper: 'Prezzo migliore trovato altrove',
      NotGoodEnoughQuality: 'Prestazioni o qualità non adeguate',
      Incompatibility: 'Incompatibile o inadeguato',
      DamagedProduct: 'Articolo danneggiato, confezione interna intatta',
      TooSlow: 'Data di consegna prevista non rispettata',
      MissingParts: 'Componenti o accessori mancanti',
      DamagedProductAndBox:
        'Prodotto e scatola di spedizione entrambi danneggiati',
      ReceivedWrongProduct: "L'articolo inviato è errato",
      ProductNotWorking: "L'articolo è difettoso o non funziona",
      DidNotBuyProduct:
        'Ricevuto articolo non ordinato (nessun rimborso necessario)',
      NotNeededAnymore: 'Non più necessario',
      UnauthorizedPurchase: 'Acquisto non autorizzato',
      MisleadingDescription: 'Descrizione sul sito non accurata',
      Other: 'Altro',
    },
    statuses: {
      ToBeDealtWith: 'Richiesta inserita',
      ApprovedAndWaitingToBeReceived: 'Approvato',
      ReceivedAndInProcess: 'Reso in elaborazione',
      Refunded: 'Rimborsato',
      Rejected: 'Rifiutato',
    },
    types: {
      Coupon: 'Buono',
      Refund: 'Rimborso',
    },
    manners: {
      CourierService: 'Ritiro a domicilio',
      SendItYourself: 'Invio in autonomia',
    },
    paymentTypes: {
      CreditCard: 'Carta di credito',
      DebitCard: 'Carta di debito',
      PayPal: 'PayPal',
      BankTransfer: 'Bonifico bancario',
      WarehousePickup: 'Pagamento al ritiro',
      IngenicoRedirectPaymentPage: 'Carta di credito',
      Soisy: 'Finanziamento',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'Finanziamento',
      HeyLight: 'Finanziamento',
    },
    courierServiceInfo:
      "Per questo servizio è previsto un contributo di {price}€. Selezionando questa opzione verrete contattati dall'assistenza per accordarsi su data e luogo di ritiro.",
  },
  'en-AU': {
    returnDetailsHeading: 'Return n. {returnNumber} details',
    returnDate: 'Request sent on:',
    returnStatus: 'Return status',
    returnType: 'Type of return',
    orderNumber: 'Return of order n. {orderNumber}',
    orderDate: 'Order placed on:',
    paymentType: 'Order payment method',
    returnManner: 'Shipment method',
    amountRefunded: 'Refunded amount',
    downloadPdf: 'Download PDF',
    pdfInstructions: 'Print the pdf and insert it inside the package',
    downloadLabel: 'Download label',
    labelInstructions:
      'Print the label and glue it on the outside of the package',
    returnedItems: 'Returned items',
    reason: 'Reason',
    notes: 'Notes',
    backToMyOrders: 'Back to my orders',
    reasons: {
      Mistake: 'Purchased by mistake',
      FoundCheaper: 'A better price found elsewhere',
      NotGoodEnoughQuality: 'Inadequate performance or quality',
      Incompatibility: 'Incompatible or inadequate',
      DamagedProduct: 'The product is damaged, the package is intact',
      TooSlow: 'The expected delivery date is not respected',
      MissingParts: 'Missing parts or accessories',
      DamagedProductAndBox: 'The product and the package are both damaged',
      ReceivedWrongProduct: 'The shipped product is incorrect',
      ProductNotWorking: "The product is defective or doesn't work",
      DidNotBuyProduct:
        'received a product I did not ordered (no refund is necessary)',
      NotNeededAnymore: 'Not necessary anymore',
      UnauthorizedPurchase: 'The purchase is not authorised ',
      MisleadingDescription: 'The description on the website is not accurate',
      Other: 'Other',
    },
    statuses: {
      ToBeDealtWith: 'Request submitted',
      ApprovedAndWaitingToBeReceived: 'Approved',
      ReceivedAndInProcess: 'Return in process',
      Refunded: 'Refunded',
      Rejected: 'Refused',
    },
    types: {
      Coupon: 'Coupon',
      Refund: 'Reimbursement',
    },
    manners: {
      CourierService: 'Home pick up',
      SendItYourself: 'Autonomous dispatch',
    },
    paymentTypes: {
      CreditCard: 'Credit card',
      DebitCard: 'Debit card',
      PayPal: 'Pay Pal',
      BankTransfer: 'Bank transfer',
      WarehousePickup: 'Pay when you pick up at warehouse',
      IngenicoRedirectPaymentPage: 'Credit card',
      Soisy: 'Soisy',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'PagoLight',
      HeyLight: 'HeyLight',
    },
    courierServiceInfo:
      'There is a charge of {price}€ for this service. If you select this option, you will be contacted by support to arrange pick-up date and location.',
  },
  'en-GB': {
    returnDetailsHeading: 'Return n. {returnNumber} details',
    returnDate: 'Request sent on:',
    returnStatus: 'Return status',
    returnType: 'Type of return',
    orderNumber: 'Return of order n. {orderNumber}',
    orderDate: 'Order placed on:',
    paymentType: 'Order payment method',
    returnManner: 'Shipment method',
    amountRefunded: 'Refunded amount',
    downloadPdf: 'Download PDF',
    pdfInstructions: 'Print the pdf and insert it inside the package',
    downloadLabel: 'Download label',
    labelInstructions:
      'Print the label and glue it on the outside of the package',
    returnedItems: 'Returned items',
    reason: 'Reason',
    notes: 'Notes',
    backToMyOrders: 'Back to my orders',
    reasons: {
      Mistake: 'Purchased by mistake',
      FoundCheaper: 'A better price found elsewhere',
      NotGoodEnoughQuality: 'Inadequate performance or quality',
      Incompatibility: 'Incompatible or inadequate',
      DamagedProduct: 'The product is damaged, the package is intact',
      TooSlow: 'The expected delivery date is not respected',
      MissingParts: 'Missing parts or accessories',
      DamagedProductAndBox: 'The product and the package are both damaged',
      ReceivedWrongProduct: 'The shipped product is incorrect',
      ProductNotWorking: "The product is defective or doesn't work",
      DidNotBuyProduct:
        'received a product I did not ordered (no refund is necessary)',
      NotNeededAnymore: 'Not necessary anymore',
      UnauthorizedPurchase: 'The purchase is not authorised ',
      MisleadingDescription: 'The description on the website is not accurate',
      Other: 'Other',
    },
    statuses: {
      ToBeDealtWith: 'Request submitted',
      ApprovedAndWaitingToBeReceived: 'Approved',
      ReceivedAndInProcess: 'Return in process',
      Refunded: 'Refunded',
      Rejected: 'Refused',
    },
    types: {
      Coupon: 'Coupon',
      Refund: 'Reimbursement',
    },
    manners: {
      CourierService: 'Home pick up',
      SendItYourself: 'Autonomous dispatch',
    },
    paymentTypes: {
      CreditCard: 'Credit card',
      DebitCard: 'Debit card',
      PayPal: 'Pay Pal',
      BankTransfer: 'Bank transfer',
      WarehousePickup: 'Pay when you pick up at warehouse',
      IngenicoRedirectPaymentPage: 'Credit card',
      Soisy: 'Soisy',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'PagoLight',
      HeyLight: 'HeyLight',
    },
    courierServiceInfo:
      'There is a charge of {price}€ for this service. If you select this option, you will be contacted by support to arrange pick-up date and location.',
  },
  'en-US': {
    returnDetailsHeading: 'Return n. {returnNumber} details',
    returnDate: 'Request sent on:',
    returnStatus: 'Return status',
    returnType: 'Type of return',
    orderNumber: 'Return of order n. {orderNumber}',
    orderDate: 'Order placed on:',
    paymentType: 'Order payment method',
    returnManner: 'Shipment method',
    amountRefunded: 'Refunded amount',
    downloadPdf: 'Download PDF',
    pdfInstructions: 'Print the pdf and insert it inside the package',
    downloadLabel: 'Download label',
    labelInstructions:
      'Print the label and glue it on the outside of the package',
    returnedItems: 'Returned items',
    reason: 'Reason',
    notes: 'Notes',
    backToMyOrders: 'Back to my orders',
    reasons: {
      Mistake: 'Purchased by mistake',
      FoundCheaper: 'A better price found elsewhere',
      NotGoodEnoughQuality: 'Inadequate performance or quality',
      Incompatibility: 'Incompatible or inadequate',
      DamagedProduct: 'The product is damaged, the package is intact',
      TooSlow: 'The expected delivery date is not respected',
      MissingParts: 'Missing parts or accessories',
      DamagedProductAndBox: 'The product and the package are both damaged',
      ReceivedWrongProduct: 'The shipped product is incorrect',
      ProductNotWorking: "The product is defective or doesn't work",
      DidNotBuyProduct:
        'received a product I did not ordered (no refund is necessary)',
      NotNeededAnymore: 'Not necessary anymore',
      UnauthorizedPurchase: 'The purchase is not authorised ',
      MisleadingDescription: 'The description on the website is not accurate',
      Other: 'Other',
    },
    statuses: {
      ToBeDealtWith: 'Request submitted',
      ApprovedAndWaitingToBeReceived: 'Approved',
      ReceivedAndInProcess: 'Return in process',
      Refunded: 'Refunded',
      Rejected: 'Refused',
    },
    types: {
      Coupon: 'Coupon',
      Refund: 'Reimbursement',
    },
    manners: {
      CourierService: 'Home pick up',
      SendItYourself: 'Autonomous dispatch',
    },
    paymentTypes: {
      CreditCard: 'Credit card',
      DebitCard: 'Debit card',
      PayPal: 'Pay Pal',
      BankTransfer: 'Bank transfer',
      WarehousePickup: 'Pay when you pick up at warehouse',
      IngenicoRedirectPaymentPage: 'Credit card',
      Soisy: 'Soisy',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'PagoLight',
      HeyLight: 'HeyLight',
    },
    courierServiceInfo:
      'There is a charge of {price}€ for this service. If you select this option, you will be contacted by support to arrange pick-up date and location.',
  },
  'de-DE': {
    returnDetailsHeading: 'Retouren Nr. {returnNumber} Details',
    returnDate: 'Anfrage gesendet am:',
    returnStatus: 'Retourenstatus',
    returnType: 'Art der Retoure:',
    orderNumber: 'Retoure der Bestellung Nr. {orderNumber}',
    orderDate: 'Bestellung aufgegeben am:',
    paymentType: 'Zahlungsmethode der Bestellung',
    returnManner: 'Versandmethode',
    amountRefunded: 'Betrag der Rückerstattung',
    downloadPdf: 'PDF herunterladen',
    pdfInstructions:
      'Drucken Sie die PDF-Datei aus und legen Sie sie in das Paket',
    downloadLabel: 'Laden Sie das Label herunter',
    labelInstructions:
      'Drucken Sie das Label aus und kleben Sie es auf die Außenseite der Verpackung.',
    returnedItems: 'Retournierte Artikel',
    reason: 'Grund',
    notes: 'Anmerkungen',
    backToMyOrders: 'Zurück zu meinen Bestellungen',
    reasons: {
      Mistake: 'Irrtümlich gekauft',
      FoundCheaper: 'Ein besserer Preis wurde anderswo gefunden',
      NotGoodEnoughQuality: 'Unzureichende Leistung oder Qualität',
      Incompatibility: 'Unvereinbar oder unzureichend',
      DamagedProduct:
        'Das Produkt ist beschädigt, die Verpackung ist unversehrt',
      TooSlow: 'Voraussichtliches Lieferdatum nicht eingehalten',
      MissingParts: 'Fehlende Komponenten oder Zubehör',
      DamagedProductAndBox: 'Produkt und Versandkarton sind beide beschädigt',
      ReceivedWrongProduct: 'Das gelieferte Produkt ist falsch',
      ProductNotWorking: 'Der Artikel ist defekt oder funktioniert nicht',
      DidNotBuyProduct:
        'Artikel erhalten, der nicht bestellt wurde (keine Rückerstattung erforderlich)',
      NotNeededAnymore: 'Nicht mehr erforderlich',
      UnauthorizedPurchase: 'Unbefugter Kauf',
      MisleadingDescription: 'Beschreibung auf der Website nicht korrekt',
      Other: 'Andere',
    },
    statuses: {
      ToBeDealtWith: 'Anfrage übermittelt',
      ApprovedAndWaitingToBeReceived: 'Genehmigt',
      ReceivedAndInProcess: 'Retoure in Bearbeitung',
      Refunded: 'Zurückerstattet',
      Rejected: 'Abgelehnt',
    },
    types: {
      Coupon: 'Gutschein',
      Refund: 'Rückerstattung',
    },
    manners: {
      CourierService: 'Abholung zu Hause',
      SendItYourself: 'Autonomer Versand',
    },
    paymentTypes: {
      CreditCard: 'Kreditkarte',
      DebitCard: 'Debitkarte',
      PayPal: 'Pay Pal',
      BankTransfer: 'Überweisung',
      WarehousePickup: 'Bezahlung bei der Abholung in unserem Sitz',
      IngenicoRedirectPaymentPage: 'Kreditkarte',
      Soisy: 'Soisy',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'PagoLight',
      HeyLight: 'HeyLight',
    },
    courierServiceInfo:
      'Für diesen Service wird eine Gebühr von {price}€ erhoben. Wenn Sie diese Option wählen, werden Sie vom Kundendienst kontaktiert, um Datum und Ort der Abholung zu vereinbaren.',
  },
  'fr-FR': {
    returnDetailsHeading: 'Détails retour n° {returnNumber}',
    returnDate: 'Demande envoyée le:',
    returnStatus: 'Statut du retour:',
    returnType: 'Type de retour:',
    orderNumber: 'Retour relatif à la commande n°{orderNumber}',
    orderDate: 'Commande effectuée le:',
    paymentType: 'Mode de paiement commande:',
    returnManner: "Mode d'expédition",
    amountRefunded: 'Montant du remboursement',
    downloadPdf: 'Téléchargez le pdf',
    pdfInstructions: 'Imprimez le pdf et insérez le dans le colis',
    downloadLabel: "Téléchargez l'étiquette",
    labelInstructions:
      "Imprimez l'étiquette et collez-la à l'extérieur du colis",
    returnedItems: 'Articles retournés',
    reason: 'Motif',
    notes: 'Notes',
    backToMyOrders: 'Retourner à mes commandes',
    reasons: {
      Mistake: 'Commandé par erreur',
      FoundCheaper: 'Meilleur prix trouvé ailleurs',
      NotGoodEnoughQuality: 'Performances ou qualité non adéquates',
      Incompatibility: 'Incompatible ou inadéquat',
      DamagedProduct: 'Article endommagé, emballage interne intact',
      TooSlow: 'Délai de livraison prévu non respecté',
      MissingParts: 'Pièces ou accessoires manquants',
      DamagedProductAndBox: 'Produit et emballage tous deux endommagés',
      ReceivedWrongProduct: 'Article envoyé par erreur',
      ProductNotWorking: 'Défectueux ou ne fonctionne pas',
      DidNotBuyProduct:
        'Article différent de celui qui a été commandé (aucun remboursement nécessaire)',
      NotNeededAnymore: "N'est plus nécessaire",
      UnauthorizedPurchase: 'Achat non autorisé',
      MisleadingDescription: 'Différent de la desciption sur le site Web',
      Other: 'Autre',
    },
    statuses: {
      ToBeDealtWith: 'Requête insérée',
      ApprovedAndWaitingToBeReceived: 'Approuvé',
      ReceivedAndInProcess: 'Retour en cours de traitement ',
      Refunded: 'Remboursé',
      Rejected: 'Refusé',
    },
    types: {
      Coupon: "Bon d'achat",
      Refund: 'Remboursement',
    },
    manners: {
      CourierService: 'Retrait à domicile',
      SendItYourself: 'Envoi en autonomie',
    },
    paymentTypes: {
      CreditCard: 'Carte de crédit',
      DebitCard: 'Carte de débit',
      PayPal: 'Pay Pal',
      BankTransfer: 'Virement bancaire',
      WarehousePickup: 'Paiement lors du retrait dans notre magasin',
      IngenicoRedirectPaymentPage: 'Carte de crédit',
      Soisy: 'Soisy',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'PagoLight',
      HeyLight: 'HeyLight',
    },
    courierServiceInfo:
      "Ce service à un coût de {price}€. Si vous sélectionnez cette option, vous serez contacté par le service d'assistance pour convenir d'une date et d'un lieu d'enlèvement.",
  },
  'es-ES': {
    returnDetailsHeading: 'Detalles devolución N.º {returnNumber}',
    returnDate: 'Solicitud enviada el:',
    returnStatus: 'Estado de la devolución:',
    returnType: 'Tipo de devolución:',
    orderNumber: 'Devolución relativa al pedido N.º {orderNumber}',
    orderDate: 'Pedido realizado el:',
    paymentType: 'Forma de pago del pedido:',
    returnManner: 'Método de envío',
    amountRefunded: 'Importe del reembolso:',
    downloadPdf: 'Descraga el pdf',
    pdfInstructions:
      'Imprimir el pdf e introducirlo en el interior del paquete',
    downloadLabel: 'Descargar la etiqueta',
    labelInstructions:
      'Imprimir la etiqueta y pegarla en el exterior del paquete',
    returnedItems: 'Artículos devueltos',
    reason: 'Motivo',
    notes: 'Notas',
    backToMyOrders: 'Volver a mis pedidos',
    reasons: {
      Mistake: 'Comprado por error',
      FoundCheaper: 'Lo he encontrado más barato',
      NotGoodEnoughQuality: 'El funcionamiento o la calidad no son adecuados',
      Incompatibility: 'Incompatible o inadecuado para la finalidad prevista',
      DamagedProduct: 'Artículo dañado, embalaje interno intacto',
      TooSlow: 'Fecha de entrega prevista no respetada',
      MissingParts: 'Faltan piezas o accesorios',
      DamagedProductAndBox: 'Producto y embalaje dañado',
      ReceivedWrongProduct: 'Producto enviado equivocado',
      ProductNotWorking: 'El artículo está defectuoso o no funciona',
      DidNotBuyProduct:
        'Artículo recibido no pedido (no es necesario el reembolso)',
      NotNeededAnymore: 'Ya no lo quiero o necesito',
      UnauthorizedPurchase: 'Compra no autorizada',
      MisleadingDescription: 'La descripción en el sitio no es exacta',
      Other: 'Otro',
    },
    statuses: {
      ToBeDealtWith: 'Petición registrada',
      ApprovedAndWaitingToBeReceived: 'Aprobado',
      ReceivedAndInProcess: 'Devolución en proceso',
      Refunded: 'Reembolsado',
      Rejected: 'Rechazado',
    },
    types: {
      Coupon: 'Bono',
      Refund: 'Reembolso',
    },
    manners: {
      CourierService: 'Recogida en domicilio',
      SendItYourself: 'Envío autónomo',
    },
    paymentTypes: {
      CreditCard: 'Tarjeta de crédito',
      DebitCard: 'Tarjeta de débito',
      PayPal: 'Pay Pal',
      BankTransfer: 'Transferencia bancaria',
      WarehousePickup: 'Paga cuando haga el retiro en nuestra sede',
      IngenicoRedirectPaymentPage: 'Tarjeta de crédito',
      Soisy: 'Soisy',
      KlarnaPayNow: 'Klarna',
      KlarnaPayLater: 'Klarna',
      KlarnaPayOverTime: 'Klarna',
      KlarnaDirectDebit: 'Klarna',
      KlarnaDirectBankTransfer: 'Klarna',
      IngenicoIDeal: 'iDEAL',
      PagoLightPro: 'PagoLight',
      HeyLight: 'HeyLight',
    },
    courierServiceInfo:
      'Este servicio tiene un coste de {price}€. Al seleccionar esta opción, el servicio de asistencia se pondrá en contacto con usted para acordar la fecha y el lugar de recogida.',
  },
};
